"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var CheckIcon_1 = require("../Icons/CheckIcon");
var TooltipIcon_1 = require("../TooltipIcon");
var withContext_1 = require("../../utils/hoc/withContext");
var propTypes = {
    title: PropTypes.string,
    hideCheckMark: PropTypes.bool,
    noPadding: PropTypes.bool,
    wide: PropTypes.bool,
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    children: PropTypes.node.isRequired
};
var RadioTileWithinContext = /** @class */ (function (_super) {
    __extends(RadioTileWithinContext, _super);
    function RadioTileWithinContext(props) {
        var _this = _super.call(this, props) || this;
        _this.handleTooltipToggle = function (isOpen) {
            _this.setState({ isTooltipOpen: isOpen });
        };
        _this.id = props.id || props.ergoElements.idGenerator.next();
        _this.state = {
            isTooltipOpen: false
        };
        return _this;
    }
    RadioTileWithinContext.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, disabled = _a.disabled, hideCheckMark = _a.hideCheckMark, title = _a.title, wide = _a.wide, tooltip = _a.tooltip, ergoElements = _a.ergoElements, noPadding = _a.noPadding, other = __rest(_a, ["children", "className", "disabled", "hideCheckMark", "title", "wide", "tooltip", "ergoElements", "noPadding"]);
        var isTooltipOpen = this.state.isTooltipOpen;
        var componentClassName = classNames(className, 'ee_radio-tile', {
            'ee_radio-tile--tooltip-open': isTooltipOpen,
            'ee_radio-tile--wide': wide
        });
        var radioTileContentClassName = classNames(className, 'ee_radio-tile__content', {
            'ee_radio-tile__content--no-padding': noPadding
        });
        return (React.createElement("div", { className: componentClassName },
            React.createElement("input", __assign({}, other, { type: "radio", disabled: disabled, id: this.id, className: "ee_radio-tile__control", "data-focus-id": this.id })),
            React.createElement("div", { className: "ee_radio-tile__wrapper" },
                React.createElement("label", { htmlFor: this.id, className: "ee_radio-tile__tile" },
                    title !== undefined && React.createElement("span", { className: "ee_radio-tile__header" }, title),
                    React.createElement("span", { className: radioTileContentClassName }, children),
                    (tooltip || !hideCheckMark) && (React.createElement("span", { className: "ee_radio-tile__footer" },
                        !hideCheckMark && React.createElement(CheckIcon_1.default, { width: 22, height: 22, className: "ee_radio-tile__check-mark" }),
                        tooltip && !disabled && (React.createElement(TooltipIcon_1.TooltipIcon, { onToggledOpen: this.handleTooltipToggle, className: "ee_radio-tile__tooltip-icon" }, tooltip))))))));
    };
    RadioTileWithinContext.propTypes = propTypes;
    RadioTileWithinContext.defaultProps = {
        title: undefined,
        hideCheckMark: false,
        noPadding: false,
        wide: false,
        tooltip: undefined,
        children: ''
    };
    return RadioTileWithinContext;
}(react_1.Component));
/**
 * The RadioTile component represents a tile in a group of tiles, one of which
 * is selectable.
 * In contrast to a [`Radio`](#!/Radio) in a [`RadioGroupRow`](#!/RadioGroupRow),
 * this component allows for a greater diversity of content and appearance.
 *
 * A `RadioTile` has a minimum height of 170px, but will be higher if the
 * content requires it.
 */
exports.RadioTile = withContext_1.withErgoElementsContext('RadioTile', RadioTileWithinContext);
exports.default = exports.RadioTile;
//# sourceMappingURL=RadioTile.js.map